/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeButton,
  BaSeDialogContext,
  BaSeIcon,
  BaSeParagraph,
  BaSeSmall1,
  BaSeTheme,
} from '@base/react';
import React, { useState } from 'react';
import { useMessage } from '../../../../hooks/messages/useMessage';
import { useInterviewService } from '../../../../hooks/services/interview-service';
import { AvaliableRuralContext } from '../../pages/candidates/context/avaliable-rural-candidate';
import {
  AtentionAlert,
  Container,
  ContainerButtons,
  ContainerSetNotes,
  HeaderAvaliableCandidate,
  ResultBox,
} from './avaliable-rural-candidate-style';
import RowAvaliation from './row-avaliation';
import { ContainerInput } from './row-avaliation-style';

function formataCPF(cpf) {
  //retira os caracteres indesejados...
  cpf = cpf.replace(/[^\d]/g, '');

  //realizar a formatação...
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

function RvaliableRuralCandidate({ settingsMap, fetchData }) {
  const { setShowAvaliableRuralCandidate, dataToAvaliationRural } =
    React.useContext(AvaliableRuralContext);
  console.log(dataToAvaliationRural);

  const dataParse = dataToAvaliationRural.scoreItems.map(
    ({ descProfileItem, scoreManualEvaluation }) => {
      return {
        descProfileItem,
        scoreManualEvaluation: dataToAvaliationRural.isEdit
          ? scoreManualEvaluation
          : undefined,
        wasEdited: dataToAvaliationRural.isEdit ? true : false,
      };
    },
  );

  const [values, setValues] = useState(dataParse);
  const [onSave, setOnSave] = useState(false);

  const { handleError, handleAttention, handleSuccess } = useMessage();
  const { showModal } = React.useContext(BaSeDialogContext);
  const { putEvaluateByCceScore } = useInterviewService();

  const showAttention = !!dataToAvaliationRural?.evaluationDate;

  const total = React.useMemo(() => {
    return values.reduce(
      (acc, item) => acc + Number(item.scoreManualEvaluation ?? 0),
      0,
    );
  }, [values]);

  const textResult = total >= 60 ? 'Apto' : 'Não Apto';

  const returnValueOfList = React.useCallback(
    (desc) => {
      const result = values.find((l) => l.descProfileItem === desc);
      return result.scoreManualEvaluation ?? 0;
    },
    [values],
  );

  const openDialogConfirm = React.useCallback(() => {
    return showModal({
      actions: [
        {
          action: 'Sim',
          type: 'primary',
          color: BaSeTheme.colors.institucionais.cinzaSebrae10,
        },
        {
          action: 'Não',
          type: 'secondary',
        },
      ],
      size: 'medium',
      title: 'Confirmar registro de nota',
      dismissible: true,
      dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
      dismissibleIconType: 'tertiary',
      content: ({ closeModal, emitEvent }) => (
        <div>
          <BaSeParagraph>
            {`Tem certeza que deseja registrar o participante como "`}
            <strong>{textResult}</strong>
            {'"?'}
          </BaSeParagraph>

          <BaSeParagraph>{`Nota informada ${total}.`}</BaSeParagraph>
        </div>
      ),
      onChooseAction: async (action) => {
        if (action === 'Sim') {
          const dto = {
            interviewId: dataToAvaliationRural.interviewId,
            persistenceScore: returnValueOfList('Persistência'),
            informationSearchScore: returnValueOfList('Busca de informação'),
            settingGoalsScore: returnValueOfList('Estabelecimento de metas'),
            calculatedRiskScore: returnValueOfList('Correr riscos calculados'),
            persuasionContactNetworkScore: returnValueOfList(
              'Persuasão e rede de contatos',
            ),
            independenceTrustScore: returnValueOfList(
              'Independência e autoconfiança',
            ),
            planMonitorScore: returnValueOfList(
              'Planejamento e monitoramento sistemático',
            ),
            opportunityIniciativeScore: returnValueOfList(
              'Busca de oportunidades e Iniciativa',
            ),
            qualityEfficiencyScore: returnValueOfList(
              'Exigência de qualidade e eficiência',
            ),
            commitmentScore: returnValueOfList('Comprometimento'),
          };
          try {
            await putEvaluateByCceScore(dto);
            handleSuccess('Operação realizada com sucesso!');
          } catch (error) {
            console.log('ddeu ruim', dto);
          }
        }
      },
    });
  }, [
    dataToAvaliationRural.interviewId,
    handleSuccess,
    putEvaluateByCceScore,
    returnValueOfList,
    showModal,
    textResult,
    total,
  ]);

  const updateValue = React.useCallback((index, newValue) => {
    setValues((prevValues) => {
      const updatedValues = [...prevValues];
      updatedValues[index].scoreManualEvaluation = newValue;
      updatedValues[index].wasEdited = true;
      return updatedValues;
    });
  }, []);

  const validEmpt = React.useCallback(() => {
    const responseValueEmpty = values.filter((v) => !v.wasEdited) ?? [];
    const countValuesIndalid =
      values.filter((v) => v.scoreManualEvaluation > 25) ?? [];
    const hasUndefined =
      values.filter((v) => v.scoreManualEvaluation === undefined) ?? [];
    if (responseValueEmpty.length > 0) {
      handleError('Preencha todos os campos.');
      return false;
    }
    if (hasUndefined.length > 0) {
      handleError('Preencha todos os campos.');
      return false;
    }
    if (countValuesIndalid.length > 0) {
      handleAttention('Nota da CCE deve ser de 0 a 25.');

      return false;
    }
    return true;
  }, [handleError, handleAttention, values]);

  const handleSave = React.useCallback(async () => {
    setOnSave(true);
    if (!validEmpt()) return;
    openDialogConfirm();
  }, [openDialogConfirm, validEmpt]);

  return (
    <div>
      <Container>
        <BaSeButton
          leftIcon="arrow-circle-left-tonescale"
          type="tertiary"
          value="Voltar"
          onClick={() => {
            setShowAvaliableRuralCandidate((prev) => !prev);
            fetchData({
              page: 0,
              sort: { type: 'DESC' },
            });
          }}
        />

        <HeaderAvaliableCandidate>
          <BaSeParagraph isBold>Registrar notas do participante</BaSeParagraph>
          <BaSeParagraph isBold>
            {`${dataToAvaliationRural.candidateName} - ${formataCPF(
              dataToAvaliationRural.candidateCpf,
            )}`}
          </BaSeParagraph>
        </HeaderAvaliableCandidate>

        <ContainerSetNotes>
          {!showAttention && (
            <AtentionAlert>
              <BaSeIcon
                name="system/alert-line"
                description="alerta"
                size={60}
                color={BaSeTheme.colors.feedbackInterface.atencao35}
              />
              <div>
                <BaSeParagraph
                  color={BaSeTheme.colors.feedbackInterface.atencao35}
                  isBold
                >
                  Atenção!
                </BaSeParagraph>
                <BaSeParagraph>
                  A entrevista deste candidato encontra-se "Aguardando
                  avaliação"; você pode inserir as notas do selecionador para
                  avaliá-lo.
                </BaSeParagraph>
              </div>
            </AtentionAlert>
          )}

          <BaSeParagraph isBold>PONTUAÇÃO DAS CCEs</BaSeParagraph>

          <div>
            {values.map(
              ({ descProfileItem, scoreManualEvaluation, nota }, index) => (
                <RowAvaliation
                  onSave={onSave}
                  key={descProfileItem}
                  title={descProfileItem}
                  value={scoreManualEvaluation}
                  onValueChange={(newValue) => {
                    updateValue(index, newValue);
                  }}
                />
              ),
            )}

            <ContainerInput>
              <BaSeSmall1 isBold>Perfil CCE do Participante</BaSeSmall1>
              <ResultBox>
                <BaSeParagraph
                  isBold
                  color={total < 60 ? '#DB0000' : '#387F3A'}
                >
                  {total}
                </BaSeParagraph>
              </ResultBox>
            </ContainerInput>
          </div>

          <ContainerButtons>
            <BaSeButton
              value="Cancelar"
              type="secondary"
              onClick={() => {
                setShowAvaliableRuralCandidate((prev) => !prev);
                fetchData({
                  page: 0,
                  sort: { type: 'DESC' },
                });
              }}
              color={settingsMap.primaryColor}
            />

            <BaSeButton
              color={settingsMap.primaryColor}
              value="Salvar"
              onClick={() => handleSave()}
            />
          </ContainerButtons>
        </ContainerSetNotes>
      </Container>
    </div>
  );
}

export default RvaliableRuralCandidate;
